$(function () {
    window.dataLayer = window.dataLayer || [];
    // Track contact form submission
    $('.wp-contact-form form').on('wpformsAjaxSubmitBeforeRedirect', function (event) {
        const form = $(this);
        dataLayer.push({
            "event": "submit_contact_form",
            "event_name": "submit_contact_form",
            "user_firstname": form.find('.form-firstname input').val(),
            "user_lastname": form.find('.form-lastname input').val(),
            "user_company": form.find('.form-company input').val(),
            "user_email": form.find('.form-email input').val(),
            "user_phone": form.find('.form-phone input[type="hidden"]').val(),
            "user_city": "",
            "subject": form.find('.form-subject textarea').val(),
            "user_province": form.find('.form-zip input').val()
        })
    });

    // track click event on product
    function trackProductClick() {
        $('.products .product').click(function (e) {
            dataLayer.push({
                "event": "select_item",
                "event_name": "select_item",
                "ecommerce": {
                    "item_list_id": "shop",
                    "item_list_name": "Shop Page",
                    "items": [JSON.parse($(this).attr('data-layer'))]
                }
            })
        })
    }

    trackProductClick();

    // Track item views
    $(document).on('facetwp-loaded', function () {
        if (FWP.loaded) {
            dataLayer.push({
                "event": "view_item_list",
                "event_name": "view_item_list",
                "ecommerce": {
                    "item_list_id": "shop",
                    "item_list_name": "Shop Page",
                    "items": $('.products .product').map(function () {
                        return JSON.parse($(this).attr('data-layer'))
                    }).toArray()
                }
            })
            trackProductClick();
        }
    });

    // Track product added to project
    $(document).on('tiaso_product_project_added', function (event, datas) {
        if (datas.project) {
            dataLayer.push({
                "event": "add_product_to_project",
                "event_name": "add_product_to_project",
                "ecommerce": {
                    "item_list_id": `${datas.project.id}`,
                    "item_list_name": datas.project.name,
                    "items": [datas.dataLayer]
                }
            })
        }
    });

    // Track project creation
    $(document).on('tiaso_project_added', function (event, datas) {
        if (datas) {
            dataLayer.push({
                "event": "add_projects",
                "event_name": "add_projects",
                "project_id": `${datas.ID}`,
            })
        }
    });

    // Track quote request
    $('.tiaso-quote-form form').on('submit', function (event) {
        dataLayer.push({
            "event": "ask_projects_quote",
            "event_name": "ask_projects_quote",
            "project_id": `${$(this).data('id')}`,
        })
    });


    // Track newsletter subscription
    $('.tiaso-newsletter-form form').on('submit', function (event) {
        dataLayer.push({
            "event": "newsletter",
            "event_name": "newsletter"
        })
    });

})